import _ from 'underscore';
import type { DebugProcessorOptions, InstrumentationLog } from '../types';

export class DebugProcessor {
  isDebugMode?: boolean;
  constructor({
    isDebugMode,
  }: DebugProcessorOptions) {
    this.isDebugMode = isDebugMode;
  }

  process(rawLogs: InstrumentationLog) {
    return _.extend(rawLogs, {
      isDebugMode: this.isDebugMode,
    });
  }
}
